import React from "react";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../../Components/ErrorBoundary/ErrorBoundary";
import LanguageSwitcher from "../../Components/languageswitcher/LanguageSwitcher";
import {Logout} from "../../Components/Actions/Actions";
import Dashboard from "./Dashboard";

const ProkuraturaPages = () => {
    const {t} = useTranslation();

    return (
        <div className="App container-fluid px-0">
            <nav className="navbar navbar-dark bg-dark px-3">
                <h1 className="navbar-brand mb-0 h5">{t("prokuratura_dashboard")}</h1>
                <div className="d-flex align-items-center gap-3">
                    <LanguageSwitcher mode={"dropdown"}/>
                    <button type="button" className="btn btn-outline-light btn-sm" onClick={Logout}>
                        <i className="bi bi-box-arrow-left pe-2" aria-hidden="true"></i>{t("exit")}
                    </button>
                </div>
            </nav>
            <main>
                <ErrorBoundary><Dashboard/></ErrorBoundary>
            </main>
        </div>
    );
};

export default ProkuraturaPages;
